import React from "react";
import { styled } from "@mui/system";
import MUIMenu from "@mui/material/Menu";
import { MenuProps as MenuPropsMUI } from "@mui/material/Menu";
export interface MenuProps extends MenuPropsMUI {}

export const Menu: (props: MenuProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, MenuProps>((props, ref) => (
    <MUIMenu ref={ref} {...props} />
  )),
  {
    name: "Menu",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "& .MuiMenu-paper .MuiList-root": {
    paddingTop: 0,
    paddingBottom: 0
  }
}));
